export default {
  emptyCart: {
    description: 'Your cart is empty.',
  },
  itemCount: {
    one: '{{count}} Item in Your Cart',
    other: '{{count}} Items in Your Cart',
  },
  startCheckoutButton: {
    text: 'Proceed to Checkout',
  },
  orderSummary: {
    title: 'Order Summary',
    salesTax: {
      label: 'Tax',
      description: 'Calculated in Checkout',
    },
  },
  freeShippingThresholds: {
    thresholdMet: "You're getting free standard shipping on orders from {{shopName}}!",
    amountRemaining: "You're {{amountRemainingDisplay}} away from getting free standard shipping from {{tagOpen}}{{shopName}}{{tagClose}}</a>.",
  },
  cartItemQuantitySelect: 'Quantity',
  cartItemPricing: {
    shipping: '{{amountDisplay}} Shipping',
    combinedShipping: {
      text: '{{amountDisplay}} Combine & Save Shipping',
      tooltip: 'Shipping discounts apply when buying multiple qualified items from this shop',
    },
    localPickupOnly: 'Local Pickup',
    description: {
      shipped: ' {{priceDisplay}} plus {{shippingDisplay}} shipping',
      localPickupOnly: '{{priceDisplay}} with local pickup',
    },
  },
  preorderEstimatedShipDate: 'Estimated ship date:',
  buyWithAffirmDefaultText: 'Buy with monthly payments through Affirm',
  buyNowPayOverTime: 'Buy now, pay over time with Affirm',
  makeMonthlyPayments: 'Make monthly payments with no hidden fees',
  splitPay: 'Make regular payments with no hidden fees',
  removeItem: 'Remove Item',
  moveToWatchList: 'Move to Watch List',
  acceptedOffer: 'Accepted Offer',
  changeShippingRegion: 'Change shipping region',
  freeExpeditedShipping: 'Free 2-Day Shipping',
  otherBuyersWithListingInCart: {
    one: '{{count}} other person has this in their cart',
    other: '{{count}} other people have this in their carts',
  },
};
